import { Adapter as t, getAdapter as i } from "../../../../adapter.js";
import { StripeReaderConfigurationAdapter as n } from "../stripeReaderConfiguration/stripeReaderConfiguration.adapter.js";
import { StripeEngineConfigModel as o } from "./stripeEngineConfig.model.js";
class g extends t {
  adapt(e) {
    const r = i(n);
    return new o({
      publicKey: e.stripe.engines.stripe.public_key,
      status: e.stripe.engines.stripe.status,
      readerConfiguration: r.adapt(
        e.stripe.engines.stripe.reader_configuration
      )
    });
  }
  serialize(e) {
    throw new Error("Method not implemented.");
  }
}
export {
  g as StripeEngineConfigAdapter
};
//# sourceMappingURL=stripeEngineConfig.adapter.js.map
